module.exports = __webpack_public_path__ + "static/media/Gregory Goyle 2.52e20247.jpg";